// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import DashboardController from "./dashboard_controller"
application.register("dashboard", DashboardController)

import FlashController from "./flash_controller"
application.register("flash", FlashController)

import SidebarController from "./sidebar_controller"
application.register("sidebar", SidebarController)

import ConfirmController from "./confirm_controller"
application.register("confirm", ConfirmController)

import ColorPickerController from "./color_picker_controller"
application.register("color-picker", ColorPickerController)

import ImageUploadController from "./image_upload_controller"
application.register("image-upload", ImageUploadController)

import MapEditorController from "./map_editor_controller"
application.register("map-editor", MapEditorController)

import InteractiveMapController from "./interactive_map_controller"
application.register("interactive-map", InteractiveMapController)

import CountdownController from "./countdown_controller"
application.register("countdown", CountdownController)

import HourlyLitersController from "./hourly_liters_controller"
application.register("hourly-liters", HourlyLitersController)

import TabsController from "./tabs_controller"
application.register("tabs", TabsController)

import ScheduledReadingsController from "./scheduled_readings_controller"
application.register("scheduled-readings", ScheduledReadingsController)

import ReadingScheduleController from "./reading_schedule_controller"
application.register("reading-schedule", ReadingScheduleController)

import DashboardFitController from "./dashboard_fit_controller"
application.register("dashboard-fit", DashboardFitController)

import SlideshowEditorController from "./slideshow_editor_controller"
application.register("slideshow-editor", SlideshowEditorController)

import SlideshowController from "./slideshow_controller"
application.register("slideshow", SlideshowController)
